import { assertIsChainId } from './typeGuards.js';
export const toChainId = (args) => {
    const { chainNamespace, chainReference } = args;
    const maybeChainId = `${chainNamespace}:${chainReference}`;
    assertIsChainId(maybeChainId);
    return maybeChainId;
};
export const fromChainId = (chainId) => {
    const idx = chainId.indexOf(':');
    const chainNamespace = chainId.substring(0, idx);
    const chainReference = chainId.substring(idx + 1);
    return {
        chainNamespace,
        chainReference,
    };
};
